import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  & > div {
    width: 100%;
  }
`;
